import { render, staticRenderFns } from "./spotlight.vue?vue&type=template&id=93dc0bfa&scoped=true&"
import script from "./spotlight.vue?vue&type=script&lang=js&"
export * from "./spotlight.vue?vue&type=script&lang=js&"
import style0 from "./spotlight.vue?vue&type=style&index=0&id=93dc0bfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93dc0bfa",
  null
  
)

export default component.exports